import { create } from 'smbls'
import app from './app.js'
import context from './context.js'

create(app, context)
